import { createContext } from 'react';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import utils from 'utils';

type ShareableLinkDocumentsContextProps = {
  currentlyDisplayedNodes: DataRoomNode[];
  selected: DataRoomNode[];
  isSelectedMode: boolean;
  isAllSelected: boolean;
  isLoading: boolean;
  documentRoute: DataRoomNode[];
  baseDocsPath: string;
  isEmptyOnThatLevel: boolean;
  selectAll: () => void;
  removeAll: () => void;
  updateSelected: (node: DataRoomNode) => void;
  onSelect: (node: DataRoomNode) => void;
  download: (nodes: DataRoomNode[]) => void;
  setCurrentlyDisplayedNodes: (nodes: DataRoomNode[]) => void;
};

export default createContext<Partial<ShareableLinkDocumentsContextProps>>({
  currentlyDisplayedNodes: [],
  selected: [],
  isSelectedMode: false,
  isAllSelected: false,
  isLoading: true,
  documentRoute: [],
  baseDocsPath: '',
  isEmptyOnThatLevel: false,
  selectAll: utils.noop,
  removeAll: utils.noop,
  updateSelected: utils.noop,
  onSelect: utils.noop,
  download: utils.noop,
  setCurrentlyDisplayedNodes: utils.noop,
});
